import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'dark' | 'light';
  align?: 'center' | 'left';
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'dark',
  align = 'center'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <header className={['mx-auto max-w-3xl', align === 'center' ? 'text-center' : 'text-left'].join(' ')} data-id="element-283" data-mp="3k0fabo8841ai">
      {eyebrow && <p className={['mb-3 text-[11px] font-extrabold uppercase tracking-[0.18em] sm:text-xs', isDark ? 'text-clay' : 'text-gold-400'].join(' ')} data-id="element-284" data-mp="gjq463cjytld">
          {eyebrow}
        </p>}
      <h2 className={['font-display text-[26px] font-bold leading-[1.15] sm:text-4xl lg:text-[42px]', isDark ? 'text-navy-900' : 'text-cream-50'].join(' ')} data-id="element-285" data-mp="6rk8ojn3du1f">
        {title}
      </h2>
      {subtitle && <p className={['mt-4 text-base leading-relaxed sm:text-lg', isDark ? 'text-navy-700/80' : 'text-cream-100/75'].join(' ')} data-id="element-286" data-mp="1t95wv5pc4b77">
          {subtitle}
        </p>}
    </header>;
}